export const ASSESSMENT_POSTERIOR = Object.freeze({
  difficultyScale: 20,
  maximumScore: 150,
  minimumScore: 60,
  priorMean: 100,
  priorStandardDeviation: 25,
});
